import React, { PropsWithChildren } from 'react';
import { useFormContext } from '@app/site/_form';
import { AbstractButton, AbstractButtonProps } from '@app/site/_form/button/AbstractButton';

export const ResetButton = (props: PropsWithChildren<AbstractButtonProps>) => {
	const form = useFormContext();

	return (
		<AbstractButton
			{...props}
			type="button"
			onClick={() => form.reset()}
			disabled={props.disabled || form.state.isSubmitting}
		/>
	);
};
